
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import globalThis_1 from './global-this.js';
import isCallable$1 from './is-callable.js';

var globalThis = globalThis_1;
var isCallable = isCallable$1;

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
};

export { getBuiltIn as default };
//# sourceMappingURL=get-built-in.js.map
